// @dynamic-i18n-keys
// Dynamic t() at line 22: template mediapopup.notifications.labelAs.label.${label} (label: aiGenerated | noAi).
//   mediapopup.notifications.labelAs.label.aiGenerated
//   mediapopup.notifications.labelAs.label.noAi
// Dynamic t() at lines 31-35: template mediapopup.notifications.labelAs.${selectedDeviations|selectedFolder}.value.${value}.
//   mediapopup.notifications.labelAs.selectedDeviations.value.true
//   mediapopup.notifications.labelAs.selectedDeviations.value.false
//   mediapopup.notifications.labelAs.selectedFolder.value.true
//   mediapopup.notifications.labelAs.selectedFolder.value.false
import React from 'react';
import { useTranslation } from 'react-i18next';
import SystemNotification from '../../../../SystemNotification/SystemNotification';
import { Notification, NotificationQueueItem } from '../../../../Notifications';

interface Props extends NotificationQueueItem {
  deviationIds?: number[];
  folderName?: string;
  label: 'aiGenerated' | 'noAi';
  value: boolean;
}

const LabelAsNotification: React.FC<Props> = ({
  id,
  queueName,
  deviationIds,
  folderName,
  label,
  value,
}) => {
  const { t } = useTranslation();
  const labelName = t(`mediapopup.notifications.labelAs.label.${label}`);

  return (
    <Notification
      id={id}
      queueName={queueName}
      cardComponent={SystemNotification}
      cardProps={{ limitTextWidth: false }}
    >
      {t(
        `mediapopup.notifications.labelAs.${
          deviationIds && deviationIds.length
            ? 'selectedDeviations'
            : 'selectedFolder'
        }.value.${value}`,
        { labelName, folderName }
      )}
    </Notification>
  );
};
LabelAsNotification.displayName = 'LabelAsNotification';

export default LabelAsNotification;
